import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BAR_CATEGORY_ID, KITCHEN_CATEGORY_ID } from 'src/config-global';

import axios from '../../utils/axios';

export interface IPurchaseAnalysisItem {
  date: string;
  totalAmount: number;
}

interface IInitialState {
  summary: {
    status: 'idle' | 'loading' | 'success' | 'failure';
    error: string | undefined;
    kitchen: IPurchaseAnalysisItem[];

    bar: IPurchaseAnalysisItem[];

    all: IPurchaseAnalysisItem[];
  };
}

const initialState: IInitialState = {
  summary: {
    status: 'idle',
    error: undefined,
    kitchen: [],
    bar: [],
    all: [],
  },
};

const purchaseAnalysis = createSlice({
  name: 'purchaseAnalysis',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseAnalysisBar.pending, (state) => {
        state.summary.status = 'loading';
      })
      .addCase(getPurchaseAnalysisBar.fulfilled, (state, action) => {
        state.summary.status = 'success';
        state.summary.bar = action.payload;
      })
      .addCase(getPurchaseAnalysisBar.rejected, (state, action) => {
        state.summary.status = 'failure';
        state.summary.error = action.error.message;
      })

      .addCase(getPurchaseAnalysisKitchen.pending, (state) => {
        state.summary.status = 'loading';
      })
      .addCase(getPurchaseAnalysisKitchen.fulfilled, (state, action) => {
        state.summary.status = 'success';
        state.summary.kitchen = action.payload;
      })
      .addCase(getPurchaseAnalysisKitchen.rejected, (state, action) => {
        state.summary.status = 'failure';
        state.summary.error = action.error.message;
      })

      .addCase(getPurchaseAnalysisKitchenAndBar.pending, (state) => {
        state.summary.status = 'loading';
      })
      .addCase(getPurchaseAnalysisKitchenAndBar.fulfilled, (state, action) => {
        state.summary.status = 'success';
        state.summary.all = action.payload;
      })
      .addCase(getPurchaseAnalysisKitchenAndBar.rejected, (state, action) => {
        state.summary.status = 'failure';
        state.summary.error = action.error.message;
      });
  },
});

export default purchaseAnalysis.reducer;

export const getPurchaseAnalysisBar = createAsyncThunk(
  'getPurchaseAnalysisBar',
  async (params: { startDate: string; endDate: string }) => {
    const { startDate, endDate } = params;
    try {
      const response = await axios.get(
        `inventory/analytics/transaction/history?startDate=${startDate}&endDate=${endDate}&transactionType=purchase&categories=${BAR_CATEGORY_ID}`
      );

      return response.data.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
);

export const getPurchaseAnalysisKitchen = createAsyncThunk(
  'getPurchaseAnalysisKitchen',
  async (params: { startDate: string; endDate: string }) => {
    const { startDate, endDate } = params;
    try {
      const response = await axios.get(
        `inventory/analytics/transaction/history?startDate=${startDate}&endDate=${endDate}&transactionType=purchase&categories=${KITCHEN_CATEGORY_ID}`
      );

      return response.data.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
);

export const getPurchaseAnalysisKitchenAndBar = createAsyncThunk(
  'getPurchaseAnalysisKitchenAndBar',
  async (params: { startDate: string; endDate: string }) => {
    const { startDate, endDate } = params;

    try {
      const response = await axios.get(
        `inventory/analytics/transaction/history?startDate=${startDate}&endDate=${endDate}&transactionType=purchase&categories=`
      );

      return response.data.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
);
